<template>
  <v-app-bar
    id="core-app-bar"
    absolute
    app
    color="transparent"
    flat
    height="88"
  >
    <v-toolbar-title class="tertiary--text font-weight-light align-self-center">
      <v-btn
        v-if="responsive"
        color="primary"
        icon
        class="inline"
        @click.stop="onClick"
      >
        <v-icon color="" large>
          mdi-menu
        </v-icon>
      </v-btn>
      <v-breadcrumbs v-if="!responsive" divider=">" class="inline">
        <span v-for="(breadcrumb, index) in breadcrumbItems" :key="index">
          <v-breadcrumbs-item
            exact
            :disabled="breadcrumb.disabled"
            :href="breadcrumb.href"
            @click="
              e => {
                e.preventDefault();
                $router.push(breadcrumb.to);
              }
            "
          >
            {{ breadcrumb.text }}
          </v-breadcrumbs-item>
          <span v-if="index < breadcrumbItems.length - 1" class="ml-2 mr-2"
            >></span
          >
        </span>
      </v-breadcrumbs>
    </v-toolbar-title>

    <v-spacer />

    <v-toolbar-items>
      <v-row align="center" class="mx-5">
        <!-- <v-text-field
          class="mr-7 primary-input"
          color="primary"
          label="Search..."
          hide-details
        /> -->

        <v-menu bottom left offset-y transition="slide-y-transition">
          <template v-slot:activator="{ on }">
            <v-btn class="toolbar-items" icon v-on="on">
              <v-badge color="accent" overlap>
                <template slot="badge">
                  {{ notifications.length }}
                </template>
                <v-icon color="primary" large>
                  mdi-bell
                </v-icon>
              </v-badge>
            </v-btn>
          </template>

          <v-card>
            <v-list dense v-if="notifications.length > 0">
              <v-list-item
                v-for="notification in notifications"
                :key="notification"
              >
                <v-list-item-title v-text="notification" />
              </v-list-item>
            </v-list>
            <v-list dense v-else>
              <v-list-item>
                <v-list-item-title>No new notification</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>

        <v-menu :nudge-width="200" class="mr-4" offset-y bottom left>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon color="primary" large>
                mdi-account
              </v-icon>
            </v-btn>
          </template>
          <v-list flat>
            <v-subheader
              >Signed in as {{ $store.getters.user.username }}</v-subheader
            >
            <v-list-item
              v-for="item in userItems"
              :key="item.title"
              :to="item.link"
            >
              <v-list-item-icon>
                <v-icon color="accent" v-text="item.icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title" />
              </v-list-item-content>
            </v-list-item>
            <v-divider />
            <v-list-item @click="handleLogout">
              <v-list-item-icon>
                <v-icon color="accent">
                  mdi-logout
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Sign Out</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-row>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
// Utilities
import { logout } from "@/utils/auth";

import { mapMutations } from "vuex";

export default {
  data: () => ({
    notifications: [],
    title: null,
    responsive: false,
    userItems: [
      { title: "My account", icon: "mdi-account", link: "/settings/account/" }
      /* {title: 'My organization', icon:'domain', link: '#/settings/organization'}, */
    ]
  }),
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    if (this.$store.getters.user.admin) {
      this.userItems.push({
        title: "My organization",
        icon: "mdi-domain",
        link: "/settings/company/"
      });
      this.userItems.push({
        title: "Members",
        icon: "mdi-account-multiple",
        link: "/settings/members/"
      });
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onClick() {
      this.setDrawer(!this.$store.state.app.drawer);
    },
    handleLogout() {
      logout();
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  },
  computed: {
    breadcrumbItems() {
      let route = this.$route;
      let els = _.filter(
        _.split(route.path.slice(1, route.path.length), "/"),
        o => {
          return o !== "";
        }
      );
      route.meta.breadcrumb = _.map(els, (p, index) => {
        let path = "";
        for (let i = 0; i < els.length; i++) {
          const e = els[i];
          path += "/" + e;
          if (e === p) {
            break;
          }
        }
        return {
          text: _.capitalize(decodeURI(p)),
          to: { path: path },
          href: path,
          disabled:
            _.endsWith(route.path, "/" + p) ||
            _.endsWith(route.path, "/" + p + "/") ||
            ["create", "update"].includes(_.lowerCase(p))
        };
      });
      return route.meta.breadcrumb;
    }
  }
};
</script>

<style>
/* Fix coming in v2.0.8 */
#core-app-bar {
  width: auto;
}

#core-app-bar a {
  text-decoration: none;
}
</style>
